import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface iSettingState {
  setting: any;
  locale: string | null;
}

const settingState: iSettingState = {
  setting: null,
  locale: 'kr',
};

export const getSetting = createAsyncThunk(
  `GET_SETTING`,
  async (_, { getState }) => {
    // const state: any = getState();

    const data = await import(`src/assets/setting/setting.json`);

    try {
      return data.default;
    } catch {
      return {};
    }
  }
);

export const settingSlice = createSlice({
  name: "setting",
  initialState: settingState,
  reducers: {
    setSetting: (state: any) => {},
    setLocale: (state: any, action: PayloadAction<string>) => {
      state.locale = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getSetting.fulfilled,
      (state: any, action: PayloadAction<any>) => {
        state.setting = action.payload;
      }
    );
  },
});

export const { setSetting, setLocale } = settingSlice.actions;

export default settingSlice.reducer;
